import React, { useEffect, useContext} from 'react'
import { StateController } from '../../App'

import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Button from '../atoms/Button'
import Icon from '../atoms/Icon'

function MechanicModal({
  show,
  setShowModal
}) {
  const { setMdalOpen } = useContext(StateController)

  useEffect(() => {
    setMdalOpen(show);
    
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const close = () => {
    setShowModal(false)
  }

  const slidesSteps = [
    {  
      title: 'Inscríbete',
      image: '/assets/images/number_1.png',
      desc: 'Participa con los últimos 5 dígitos de tu documento de identidad y tu fecha de nacimiento.',
    },
    { 
      title: 'Elige tu meta y premio',
      image: '/assets/images/number_2.png',
      desc: 'Selecciona la meta de facturación y compras que deseas alcanzar. Luego, escoge tu bono favorito.',
    },
    { 
      title: 'Compra y gana',
      image: '/assets/images/number_3.png',
      desc: '¡Todas tus compras suman! Al alcanzar tu meta, podrás descargar el bono que elegiste.',
    },
  ]
  
  return (
    <div className={`mc-mechanic-modal ${show && 'mc-mechanic-modal__opened'} slow_ani`}>
      <div className="mc-mechanic-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-mechanic-modal__center">
        <VerticalCenter>
          <div className="mc-mechanic-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-mechanic-modal__center--window slow_ani`}>
          <img src='/assets/images/confeti_mechanic_modal.png' className='confeti_izq' alt='confeti_izq'/>
            <div>
              <div className={`mc-mechanic-modal__center--window__title`}>
                <p>¿Cómo ganar?</p>
              </div>
              <div className={`mc-mechanic-modal__center--window__subtitle`}>
                <p>Entre más compres más oportunidades tienes de ganar con tu Tarjeta de Crédito Mastercard del Banco de Bogotá.</p>
              </div>
              <h5>
                Paso a paso
              </h5>
              <div className={`mc-mechanic-modal__center--window__desc`}>
                {slidesSteps.map((step, index) => {   
                  return (
                    <div key={index} className={`participar-steps__items--item`}>
                      <div className='participar-steps__items--item--desc'>
                        <img src={step.image} alt={step.image} />
                        <div>
                          <h6>
                            {step.title}
                          </h6>
                          <p dangerouslySetInnerHTML={{ __html: step.desc}} />
                        </div>
                      </div>
                    </div>
                  )  
                })}
              </div>
            </div>
            <div className={`mc-mechanic-modal__center--window__actions`}>
              <Button
                type="secondary"
                text={'Cerrar'}
                loading={false}
                status="active"
                onClick={close}
              />
            </div>
          </div>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default MechanicModal